/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { StatusIndicator, Typography } from '@neo4j-ndl/react';

const Component = () => {
  return (
    <div className="n-flex n-gap-token-16">
      <div className="n-flex n-flex-col n-items-center n-gap-token-8">
        <StatusIndicator variant="unknown" />
        <Typography variant="label">Unknown</Typography>
      </div>
      <div className="n-flex n-flex-col n-items-center n-gap-token-8">
        <StatusIndicator variant="success" />
        <Typography variant="label">Success</Typography>
      </div>
      <div className="n-flex n-flex-col n-items-center n-gap-token-8">
        <StatusIndicator variant="info" />
        <Typography variant="label">Info</Typography>
      </div>
      <div className="n-flex n-flex-col n-items-center n-gap-token-8">
        <StatusIndicator variant="warning" />
        <Typography variant="label">Warning</Typography>
      </div>
      <div className="n-flex n-flex-col n-items-center n-gap-token-8">
        <StatusIndicator variant="danger" />
        <Typography variant="label">Danger</Typography>
      </div>
    </div>
  );
};

export default Component;
